declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { ActorService } from '../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, SaveCounsellingPlanRequest, SaveFollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SaveFollicularScanOvaryDetailRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveFollicularPickupsDetailV2Request, TreatmentCycleStatusController, TreatmentCycleStatusRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveTestMedCycleActivitiesRequest, FormOrganizer, SaveCycleStatusRequest, RefundDetailsData, RefundDetailsRequest, RefundDetailsController, RefundItemDetailsController, SaveRefundApprovalRequest } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../src/app/ncs/services/fd.service';
//import { NgbEditOvaryModal } from '../editovary';
import { ScansPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
//import { NgbAddScanTestModal } from './addscantest.modal';
//import { NgbAddScanMedicineModal } from './addscanmedicine.modal';
//import { NgbEditScanMedicineModal } from './editscanmedicine.modal';
//import { NgbEditScanTestModal } from './editscantest.modal';
//import { NgbEventAddModal } from '../TreatmentCycle/eventadd.modal';
import { PrintService } from '../../../services/print.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivf/ivfworkbench/editovary.modal';
import { NgbAddScanMedicineModal } from '../ivf/ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivf/ivfworkbench/editscanmedicine.modal';
import { NgbAddScanTestModal } from '../ivf/ivfworkbench/addscantest.modal';
import { NgbEditScanTestModal } from '../ivf/ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from '../ivf/TreatmentCycle/eventadd.modal';


@Component({
  selector: 'refundreqitems',
  templateUrl: './refundreqitems.component.html',
    styleUrls: ['./refundreqitems.component.scss'],
  animations: [routerTransition()]
})

export class RefundreqItemsComponent implements OnInit {
 
   // @Input() Refundcode: number;
  currentPage: string = "About"
  public isRequesting: boolean = false;
  public Changes: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
  CurrentSaveFollicularScanDetailRequest: SaveFollicularScanDetailRequest;
    CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
    CurrentSaveRefundApprovalRequest: SaveRefundApprovalRequest;
  CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
    CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
  CurrentSaveFollicularPickupsDetailV2Request: SaveFollicularPickupsDetailV2Request;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  NextScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public SelectedActorCode: number;
  public LoadCycleActivities: boolean = true;
  public CanLoadReport: boolean = true;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
    public PatientActorCode: number;
    public Comments: string;
    public Refundcode: any;
  public PatientCycleCode: number;
  public displayPatientdata: boolean = true;
  public displayscansdata: boolean = false;
  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;
  private isvisible: boolean = true;
  private isvisibleendo: boolean = true;
  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;
  public LMPDate: Date;
  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showscan: boolean = true;
  public Doc1: string;
  public Antag: string;
  public Stimulation: string;
  public EggActorCode: number;
    public Showivf: boolean = false;
    public DetailsSection: boolean = false;
  //
  TodayDate = new Date();

  CurrentFollicularScansBetweenDateController: FollicularScansBetweenDateController[];
  CurrentFollicularScansBetweenDateRequest: FollicularScansBetweenDateRequest;

  LoadForms() {
    this.CurrentFollicularScansBetweenDateRequest = new FollicularScansBetweenDateRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScansBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentFollicularScansBetweenDateController;
    this.GetFollicularScansBetweenDateController();
  }
  public SelectedReport: string;

  GetFollicularScansBetweenDateController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentFollicularScansBetweenDateRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentFollicularScansBetweenDateRequest.FromDate = new Date();
    this.CurrentFollicularScansBetweenDateRequest.ToDate = new Date();
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScansBetweenDateController(this.CurrentFollicularScansBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScansBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentFollicularScansBetweenDateController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  LoadActivities() {
    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = 43572;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 30;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingActivitiesByTimeController();
  }
  GetCounsellingActivitiesByTimeController() {
    this.StartRefreshing();
    //this.spinner.show();

    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //this.RefreshPatientsByDate();
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    CurrentRefundDetailsData: RefundDetailsData[];
    CurrentRefundDetailsMaster: RefundDetailsData;
    CurrentRefundDetailsRequest: RefundDetailsRequest;
    MasterData: RefundDetailsController;
    ItemsData: RefundItemDetailsController[]; 
    RefundItems(Refundcode:number) {
        //this.spinner.show();
        this.CurrentRefundDetailsRequest = new RefundDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentRefundDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
       // this.pdata = this.CurrentRefundDetailsData;
        // this.pdata = this.CurrentFollicularScansBetweenDateController;
        this.GetRefundDetailsController(Refundcode);
    }
   

    GetRefundDetailsController(Refundcode:number) {
        this.StartRefreshing();
        //this.spinner.show();
        this.CurrentRefundDetailsRequest.Facility = 2;
        this.CurrentRefundDetailsRequest.RefundCode = Refundcode;
        this.CurrentRefundDetailsRequest.ConditionalOperator = 20;
        this.CurrentRefundDetailsRequest.FromDate = new Date();
        this.CurrentRefundDetailsRequest.ToDate = new Date();
        this.CurrentRefundDetailsRequest.RequestStatus = "";
      
        this.actorservice.RefundDetailsData(this.CurrentRefundDetailsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    const res = this.ApiResData.Result || (this.ApiResData as any).result;
                    this.CurrentRefundDetailsData = Array.isArray(res) ? res : [res];
                    this.CurrentRefundDetailsMaster = Array.isArray(res) ? res[0] : res;
                    if (this.CurrentRefundDetailsMaster) {
                      this.MasterData = this.CurrentRefundDetailsMaster.Master;
                      this.ItemsData = this.CurrentRefundDetailsMaster.Items;
                    }
                    //this.pdata = this.CurrentRefundDetailsController;
                   // this.spinner.hide();
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    //this.spinner.hide();
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal, private filter: ScansPipe, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter) {

    //stepObject.init();
    //webGlObject.init();
    //this.LMPDate = this.SelectedpatientDetails.LMP;
  }


    ngOnInit() {
        this.Refundcode = this.route.snapshot.paramMap.get('Refundcode');
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    //this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
      this.RefundItems(this.Refundcode);
    this.LoadForms();
    this.LoadActivities();
    this.CurrentSaveFollicularPickupsDetailV2Request = new SaveFollicularPickupsDetailV2Request();

    this.CurrentSaveFollicularPickupsDetailV2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    //this.LoadScansData();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    //if (this.FollicularScanEndInfo.ScanDate != null) {
    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
    //  if (SValidFrom.getFullYear() > 1900) {
    //    console.log('this.StartDate >1990');
    //    this.ScanDate = {

    //      year: SValidFrom.getFullYear(),
    //      month: SValidFrom.getMonth() + 1,
    //      day: SValidFrom.getDate()
    //    }
    //  }
    //}

    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;
    this.CurrentSaveFollicularScanDetailRequest = new SaveFollicularScanDetailRequest();

    this.CurrentSaveFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveFollicularScanOvaryDetailRequest = new SaveFollicularScanOvaryDetailRequest();
        this.CurrentSaveFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveRefundApprovalRequest = new SaveRefundApprovalRequest();
        this.CurrentSaveRefundApprovalRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
    this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
    this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //
    this.CurrentSaveTestMedCycleActivitiesRequest = new SaveTestMedCycleActivitiesRequest();
    this.CurrentSaveTestMedCycleActivitiesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;


  }
  public viewmode: string = 'view';
  public fo: FormOrganizer;

  SetForm() {

    this.fo = new FormOrganizer();

    this.fo.Sections = new Array<SectionData>();
    var i = 0;
    while (i < this.FormData.length) {
      this.fo.Sections.push(this.FormData[i]);
      i++;
    }
    this.fo.Organize();
    this.spinner.hide();
  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {
    this.spinner.show();
    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = reportCode;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          this.SetForm();
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }
  SaveEndometriumdetails(CurrentFollicularScanDetails: FollicularScanDetailController) {
    //alert("Scans Data");
    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness = CurrentFollicularScanDetails.EndometriumThickness;
    //this.CurrentSaveFollicularScanDetailRequest.Remarks = CurrentFollicularScanDetails.Comments;
    //(this.CurrentSaveFollicularScanDetailRequest.EndometriumDetails);
    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = CurrentFollicularScanDetails.ScanDate;
    //if (this.CurrentSaveFollicularScanDetailRequest.ScanDate != null) {
    //  var SValidFrom = new Date(this.CurrentSaveFollicularScanDetailRequest.ScanDate);
    //  if (SValidFrom.getFullYear() > 1900) {
    //    console.log('this.StartDate >1990');
    //    this.ScanDate = {

    //      year: SValidFrom.getFullYear(),
    //      month: SValidFrom.getMonth() + 1,
    //      day: SValidFrom.getDate()
    //    }
    //  }
    //}
  }
  onAssignedToActorCodesurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
      // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodeAsstSurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveFollicularScanDetailRequest.Sign2 = event;
      //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
      //this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onSubmit() {
    this.isvisibleendo = false;
    this.spinner.show();
    this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness = this.FollicularScanEndInfo.EndometriumThickness;
    this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
    this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentSaveFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
    this.CurrentSaveFollicularScanDetailRequest.Doc = this.SelectedpatientDetails.DOC;
    this.CurrentSaveFollicularScanDetailRequest.ActorType = AppData.Instance().UserLoginDetails.ActorType.toString();
    this.CurrentSaveFollicularScanDetailRequest.ActorID = this.SelectedpatientDetails.ActorID;
    this.CurrentSaveFollicularScanDetailRequest.CycleActivity = this.SelectedpatientDetails.CycleActivity;
    this.CurrentSaveFollicularScanDetailRequest.EndometriumDetails = "";
    this.CurrentSaveFollicularScanDetailRequest.EndometriumThicknessUnits = this.FollicularScanEndInfo.EndometriumThicknessUnits;
    this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = this.FollicularScanEndInfo.Sign1Actor;
    this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = this.FollicularScanEndInfo.Sign2Actor;

    this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 20;
    this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.isvisibleendo = true;
            //this.activeModal.close();
            this.clearData();
            this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );


    }
   

  onSubmitOvary() {
    this.isvisible = false;
    this.spinner.show();
    this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = 0;
    this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    // this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
    this.CurrentSaveFollicularScanOvaryDetailRequest.ConditionalOperator = 10;
    this.actorservice.SaveFollicularScanOvaryDetail(this.CurrentSaveFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.isvisible = true;
            this.LoadOvaryData();
            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            this.spinner.hide();
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }

  onSubmitAdditional() {
    this.isvisibleendo = false;
    this.spinner.show();
    this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveFollicularScanDetailRequest.BloodFlowZone = this.FollicularScanEndInfo.BloodFlowZone;
    //this.CurrentSaveFollicularScanDetailRequest.UALeft = this.FollicularScanEndInfo.U;

    //this.CurrentSaveFollicularScanDetailRequest.UARight = this.FollicularScanEndInfo.UterineArteryRight;
    this.CurrentSaveFollicularScanDetailRequest.PILeft = this.FollicularScanEndInfo.PILeft;
    this.CurrentSaveFollicularScanDetailRequest.PIRight = this.FollicularScanEndInfo.PIRight;

    this.CurrentSaveFollicularScanDetailRequest.RILeft = this.FollicularScanEndInfo.RILeft;
    this.CurrentSaveFollicularScanDetailRequest.RIRight = this.FollicularScanEndInfo.RIRight;


    this.CurrentSaveFollicularScanDetailRequest.Evion = this.FollicularScanEndInfo.Evion;
    this.CurrentSaveFollicularScanDetailRequest.GCSF = this.FollicularScanEndInfo.GCSF;
    this.CurrentSaveFollicularScanDetailRequest.BAPC = this.FollicularScanEndInfo.BAPC;



    this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 15;
    this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.isvisibleendo = true;
            //this.activeModal.close();
            this.clearData();
            this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );


  }
  //isLeft: boolean;
  //isRight: boolean;
  //lorProgress: boolean = false;
  //LeftOrRight(lor: string, c: string) {
  // var checked : boolean = false;
  //  if (c == "true")
  //    checked = false;
  //  else 
  //    checked = true ;

  // if (!this.lorProgress) {
  //    if (lor == 'Left') {
  //    this.lorProgress = true;
  //    if (checked)
  //      this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = "Left";
  //     else
  // this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = "Right";
  //   this.isLeft = checked;
  //    this.isRight = checked;
  //      this.lorProgress = false;
  //    }
  //    else if (lor == 'Right') {
  //      this.lorProgress = true;
  //      if (checked)
  //        this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = "Right";
  //else
  //  this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = "Left";
  //     this.isRight = checked;
  //      this.isLeft = !checked;
  //     this.lorProgress = false;
  //   }

  //  }

  //}

    SelectedItems: RefundItemDetailsController;
    DisplaySelectedItems(objCategory: any) {

        var Patient: RefundItemDetailsController = objCategory;
        if (Patient != null) {
            this.SelectedpatientDetails = null;
            this.SelectedItems = Patient;
            this.DetailsSection = true;
            //this.ngOnChanges2(this.changes);
        }

    }
    onSubmitApproval() {
        this.isvisible = false;
        this.spinner.show();
        this.CurrentSaveRefundApprovalRequest.ConditionalOperator = 10;
        this.CurrentSaveRefundApprovalRequest.BillNo = "";
        this.CurrentSaveRefundApprovalRequest.ChargeType = this.MasterData.ChargeType;
        this.CurrentSaveRefundApprovalRequest.FirstLevelApprovedUser = this.MasterData.FirstLevelApprovedUser;
        this.CurrentSaveRefundApprovalRequest.SecondLevelApprovedUser = this.MasterData.SecondLevelApprovedUser;
        this.CurrentSaveRefundApprovalRequest.PatientChargeItemCode = this.SelectedItems.PatientChargeItemCode;
        this.CurrentSaveRefundApprovalRequest.RefundRequestCode = this.SelectedItems.RefundRequestCode;
        this.CurrentSaveRefundApprovalRequest.RefundRequestItemCode = this.SelectedItems.RefundRequestItemCode;
        this.CurrentSaveRefundApprovalRequest.RefundTotal = this.SelectedItems.RefundTotal;
        this.CurrentSaveRefundApprovalRequest.Comments = this.Comments;
        this.CurrentSaveRefundApprovalRequest.CreatedTimeStamp = new Date();
        this.actorservice.SaveRefundApproval(this.CurrentSaveRefundApprovalRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.isvisible = true;
                        this.LoadOvaryData();
                        //this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {
                        this.spinner.hide();
                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }

  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentFollicularScansBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentFollicularScansBetweenDateController,
          this.listFilter);
      }
    }
  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }

  dataChanged(newobj) {

    this._GetFollicularScansBetweenDateController()
  }
  _GetFollicularScansBetweenDateController() {
    this.StartRefreshing();

    this.CurrentFollicularScansBetweenDateRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentFollicularScansBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentFollicularScansBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScansBetweenDateController(this.CurrentFollicularScansBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScansBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentFollicularScansBetweenDateController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetFollicularScansBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetFollicularScansBetweenDateController();
    //ind++;
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  SelectedpatientDetails: FollicularScansBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: FollicularScansBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadCycles();
      this.LoadScansData();
      this.LoadOvaryData();
      this.LoadTestData();
      this.LoadMedicineData();
      this.LoadLmp()
      this.LoadCycleActivities = true;
      this.CanLoadReport = true;
      //this.ngOnChanges2(this.changes);
    }

  }
  Selectedpatient2(objCategory: any) {
    var Patient: FollicularScansBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      //this.ScanDetails = true;
      this.displayPatientdata = false;
      this.displayscansdata = true;
      this.LoadCycles();
      this.LoadScansData();
      this.LoadOvaryData();
      this.LoadTestData();
      this.LoadMedicineData();
      this.LoadLmp();
      this.CanLoadReport = true;
    }

  }
  LoadLmp() {
    this.LMPDate = this.SelectedpatientDetails.LMP;
  }

  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  FollicularData: TreatmentCycleStatusController[];
  FollicularData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    // this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
      //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
      this.spinner.show();
    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.FollicularData = this.ApiResData.Result;
          var Follicularlist = this.FollicularData.filter(
            function (b) {
              return b.PhaseActivity == "Follicular Scans";
            });
          this.FollicularData = Follicularlist;
          this.FollicularData2 = this.FollicularData[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //  this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentFollicularScanDetailController: FollicularScanDetailController[];
  FollicularScanEndInfo: FollicularScanDetailController;
  CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

  LoadScansData() {
    //alert("ScansData")
    this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanDetailController();
  }

  GetFollicularScanDetailController() {
    //this.StartRefreshing();

    this.CurrentFollicularScanDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentFollicularScanDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanDetailController = this.ApiResData.Result;
          this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];

          if (this.FollicularScanEndInfo.ScanDate != null) {
            var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.ScanDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          if (this.FollicularScanEndInfo.NextDocDate != null) {
            var SValidFrom = new Date(this.FollicularScanEndInfo.NextDocDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.NextScanDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
  FollicularScanOvaryInfo: FollicularScanOvaryDetailController;
  CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

  LoadOvaryData() {
    //alert("ScansData")
    this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanOvaryDetailController();
  }

  GetFollicularScanOvaryDetailController() {
    //this.StartRefreshing();

    this.CurrentFollicularScanOvaryDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentFollicularScanOvaryDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
          this.FollicularScanOvaryInfo = this.CurrentFollicularScanOvaryDetailController[0];
          //this.SelectedActorCode = this.CurrentFollicularScanOvaryDetailController[0].ActorID;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          this.LoadPatients();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.EggActorCode = this.ActorCodeDetails.EggActorCode;
          // this.ActorCodeLoad();
          // alert(this.ActorCodeDetails.EggActorCode);
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  dataAcotrCode(newobj) {
    this.ActorCodeLoad();

  }
  ActorCodeLoad() {
    //alert(this.ActorCodeDetails.EggActorCode);
    var SelectedActorCode = this.SelectedpatientDetails.ActorID;
    return SelectedActorCode;
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.SelectedpatientDetails.ActorID;
      return OwnerActorCode;
    }
  }

  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularScanEndInfo.ScanDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetDsADetails(ActorCode: number, Date: Date) {


  //}
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
    this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    // this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
    this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadPlanDetails();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  onSubmit_NextScanDate() {
    this.isvisibleendo = false;
    this.spinner.show();
    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness = this.FollicularScanEndInfo.EndometriumThickness;
    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
    this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveFollicularScanDetailRequest.NextScanDate = new Date(this.parserFormatter.format(this.NextScanDate));
    //this.CurrentSaveFollicularScanDetailRequest.NextScanDate=
    //this.CurrentSaveFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
    //this.CurrentSaveFollicularScanDetailRequest.Doc = this.SelectedpatientDetails.DOC;
    //this.CurrentSaveFollicularScanDetailRequest.ActorType = AppData.Instance().UserLoginDetails.ActorType.toString();
    //this.CurrentSaveFollicularScanDetailRequest.ActorID = this.SelectedpatientDetails.ActorID;
    //this.CurrentSaveFollicularScanDetailRequest.CycleActivity = this.SelectedpatientDetails.CycleActivity;
    //this.CurrentSaveFollicularScanDetailRequest.EndometriumDetails = "";
    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThicknessUnits = this.FollicularScanEndInfo.EndometriumThicknessUnits;
    // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = this.FollicularScanEndInfo.Sign1Actor;
    //this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = this.FollicularScanEndInfo.Sign2Actor;

    this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 27;
    this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            // this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.isvisibleendo = true;
            //this.activeModal.close();
            this.clearData();
            this.LoadScansData();

            this.NewActivity();

            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  CurrentIvfTreatmentPlanController: IvfTreatmentPlanController[];
  PlanDetails: IvfTreatmentPlanController;
  CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
  LoadPlanDetails() {
    this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
    this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentIvfTreatmentPlanRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
    this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


    this.GetIvfTreatmentPlanController();
  }
  GetIvfTreatmentPlanController() {
    //this.StartRefreshing();
    //this.spinner.show();

    this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
          this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];

            this.spinner.hide();
          //this.stopRefreshing();
          // this.LoadActivities();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  NewActivity() {
    //alert("On Submit");

    this.CurrentSaveTestMedCycleActivitiesRequest.PlanCode = this.PlanDetails.FollowupPlanCode;
    this.CurrentSaveTestMedCycleActivitiesRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = new Date(this.parserFormatter.format(this.NextScanDate));
    this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "10:00";
    this.CurrentSaveTestMedCycleActivitiesRequest.FollowupMode = "Email";
    this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "Active";
    this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
    this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
    this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
    this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
    this.CurrentSaveTestMedCycleActivitiesRequest.CycleActivityCode = 0;

    if (this.SelectedpatientDetails.EggSourceType == "Self") {
      this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.ActorCodeDetails.OwnerActorCode;
      this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType = "SELF";
    }

    else if (this.SelectedpatientDetails.EggSourceType = "Donor") {
      this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.ActorCodeDetails.EggActorCode;
      this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType = "DONOR";
    }
    this.CurrentSaveTestMedCycleActivitiesRequest.ClinicalOrderEntryCode = 0;
    this.CurrentSaveTestMedCycleActivitiesRequest.LoginUserActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveTestMedCycleActivitiesRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveTestMedCycleActivitiesRequest.BasePrice = 0;
    this.CurrentSaveTestMedCycleActivitiesRequest.CycleTestCode = 0;
    this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.GetDoc(new Date(this.parserFormatter.format(this.NextScanDate)));
    this.CurrentSaveTestMedCycleActivitiesRequest.TestCode = 124;
    this.CurrentSaveTestMedCycleActivitiesRequest.ServiceName = "FOLLICULAR GROWTH SCAN";
    this.CurrentSaveTestMedCycleActivitiesRequest.Remarks = "";
    //alert(this.GetDoc(new Date(this.parserFormatter.format(this.NextScanDate))));
    //this.cure
    this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 10;

    this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          //this.activeModal.close();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  NewDate: Date = new Date();
  GetDoc(nextscandate: Date): number {
    var Datenew = new Date(nextscandate)
    var LMPDay = Datenew.getDate();
    //alert(this.LMPDay);
    var CurrentDay = this.NewDate.getDate();
    //alert(this.CurrentDay);
    var Doc = (CurrentDay - LMPDay) + 1;
    return Doc;
  }

  clearData() {
    this.CurrentSaveFollicularScanOvaryDetailRequest.Count = null;
    this.CurrentSaveFollicularScanOvaryDetailRequest.Size = null;
    this.CurrentSaveFollicularScanOvaryDetailRequest.Remarks = null;

  }
  //Selectedpatient2() {
  //  this.displayPatientdata = false;
  //  this.displayscansdata = true;
  //}
  BackToPatientdata() {
    this.displayPatientdata = true;
    this.displayscansdata = false;
  }
  BackTodashboard() {
    //this.Showivf = true;
    //this.Showscan = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  BackTodashboard2() {
    //this.Showivf = true;
    //this.Showscan = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  edit(l: FollicularScanOvaryDetailController) {

    this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = l.OvarPos;
    this.CurrentSaveFollicularScanOvaryDetailRequest.Count = l.Count;
    this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = l.FollicularGrowth;
    this.CurrentSaveFollicularScanOvaryDetailRequest.Size = l.Size;
    this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = l.PatientCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = l.TreatmentCycle;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = l.FollicularGrowth;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = l.FollicularGrowthDetailCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.Remarks = l.Comments;


    const modalRef = this.modalService.open(NgbEditOvaryModal,
      {
        centered: true

      })
    modalRef.componentInstance.CurrentSaveFollicularScanOvaryDetailRequest = this.CurrentSaveFollicularScanOvaryDetailRequest;
    modalRef.result.then(x => { this.GetFollicularScanOvaryDetailController() })
  }
  del_(FollicularGrowthDetailCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(FollicularGrowthDetailCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(FollicularGrowthDetailCode: any) {


    console.log('..................');
    //this.StartRefreshing();
    this.CurrentSaveFollicularScanOvaryDetailRequest.ConditionalOperator = 30;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = FollicularGrowthDetailCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveFollicularScanOvaryDetail(this.CurrentSaveFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadOvaryData();

            // this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  AddTests() {
    const modalRef = this.modalService.open(NgbAddScanTestModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;


    //if (this.SelectedpatientDetails.EggSourceType == 'Donor') {
    //    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.EggActorCode;
    //}
    //else if (this.SelectedpatientDetails.EggSourceType == 'self'){
    //    modalRef.componentInstance.ActorCode1 = this.SelectedpatientDetails.ActorID;

    //}
    modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;
    modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleTestByCodeController[0].ClinicalOrderItem;
    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
  }
  AddMedicine() {
    const modalRef = this.modalService.open(NgbAddScanMedicineModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
      modalRef.componentInstance.Typeofscreen = 'Scan';
      modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
    modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    modalRef.componentInstance.ScanDate = this.FollicularScanEndInfo.ScanDate;    
    //if (this.SelectedpatientDetails.EggSourceType == 'Donor') {
    //    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.EggActorCode;
    //}
    //else if (this.SelectedpatientDetails.EggSourceType == 'self') {
    //    modalRef.componentInstance.ActorCode1 = this.SelectedpatientDetails.ActorID;

    //}

    modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    // alert(modalRef.componentInstance.ActorCode1);
    modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
    modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  EditMedicine(l: IvfCycleMedicineByCodeController) {
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
    this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
    this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
    this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
    this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
    this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;

    //this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode
    //this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;

    //this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
    //this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
    //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;
    //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";



    const modalRef = this.modalService.open(NgbEditScanMedicineModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
    //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
    modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  EditTest(l: IvfCycleTestByCodeController) {

    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
    this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
    this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
    this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
    this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
    this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

    const modalRef = this.modalService.open(NgbEditScanTestModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
    //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  delTEST(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiesTest(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesTest(l: any) {
    var item = l as IvfCycleTestByCodeController;



    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.ActorID;

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadOvaryData();
            this.LoadTestData();
            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  AddEventDetails() {
    const modalRef = this.modalService.open(NgbEventAddModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  delMedicine(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesMedicine(l: any) {
    var item2 = l as IvfCycleMedicineByCodeController;

    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;

    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.SelectedpatientDetails.ActorID;

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  pickup() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false,
    }).then(() => {

      this.IsReadyForPickup();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  IsReadyForPickup() {


    console.log('..................');
      //  this.StartRefreshing();
      this.spinner.show();
    this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 1;

    this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycle;
    this.CurrentSaveFollicularPickupsDetailV2Request.DOC = this.SelectedpatientDetails.DOC;
    this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowthCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadScansData();
            this.LoadOvaryData();
            this.LoadTestData();
              this.LoadMedicineData();
              this.spinner.hide();
            //this.ShowList = true;
            //this.LoadMedicineData();

            // this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
    Assessment() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.IsAssessmentCompeted();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    IsAssessmentCompeted() {


        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveCycleStatusRequest.ConditionalOperator = 30;

        this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycle;
        this.CurrentSaveCycleStatusRequest.ActivityName = "Oocyte Assessment";
        this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
        this.CurrentSaveCycleStatusRequest.Remarks = "None";
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.LoadCycles();
                        //this.LoadScansData();
                        //this.LoadOvaryData();
                        //this.LoadTestData();
                        //this.LoadMedicineData();
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

  //printfollicular() {
  //  this.router.navigate(['print/folliculargrowth', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
  //}
  printfollicular2() {
    this.printService.printDocument("follicularscans",
      {
        ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, CycleType: this.SelectedpatientDetails.CycleType, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo,
        DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
        GradingModelData: this.SelectedpatientDetails.GradingModel, TcModelData: this.SelectedpatientDetails.TCModelName
      },

    );

    //    this.router.navigate(['print/follicularscans', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
  }
}
